import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import Form from './forms/EventForm';
import List from './lists/event/EventList';
import Calendar from './lists/event/EventCalendar';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import {SelectButton} from "primereact/selectbutton";
import EventReservationEditor from "./EventReservationEditor";
import ModalEditor from "./ModalEditor";

const listTypes = [
    {label: 'Naptár', value: 'calendar', type: Calendar},
    {label: 'Táblázat', value: 'table', type: List}
];

class EventEditor extends React.Component {

    state = {
        listType: 'calendar'
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const ListBox = this.props.list || Box;
        const EditorBox = this.props.editor || BoxEditor;
        const ListType = listTypes.find((v) => v.value === this.state.listType).type || List;
        return (
            <Fragment>
                <ListBox
                    {...this.props}
                    theme="default"
                    header={"Események"}
                    actions={<SelectButton
                        value={this.state.listType}
                        options={listTypes}
                        onChange={(e) => this.setState({listType: e.value || listTypes[0].value})}
                    />}
                    footer={[
                        <Button
                            key="0"
                            disabled={this.props.isLoading}
                            color="default"
                            onClick={this.pristineForm}
                        >
                            Új
                        </Button>
                    ]}
                >
                    <ListType ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </ListBox>
                <EditorBox
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={"Esemény"}
                    footer={[
                        <Button
                            key="0"
                            disabled={!this.props.dirty || this.props.isLoading}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>,
                        <Button
                            key="1"
                            disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                            color="danger"
                            className="pull-left"
                            onClick={this.props.deleteForm}
                        >
                            Törlés
                        </Button>
                    ]}
                >
                    <Form {...this.props} />
                </EditorBox>
                {
                    this.props.values[this.props.componentConfig.idfield] &&
                    <EventReservationEditor
                        editorContext="EventEventReservationEditor"
                        gridid={"EventEventReservationList"}
                        presets={{event: this.props.values}}
                        isLoading={this.props.isLoading}
                        editor={ModalEditor}
                        selection={null}
                        listFilter={[
                            {
                                field: "event",
                                value: this.props.values[this.props.componentConfig.idfield]
                            }
                        ]}
                    />
                }
            </Fragment>
        );
    }
}

export default createEditor({
    componentName: "Event",
    WrappedComponent: EventEditor,
    props: {
        componentActions: (action, data, params) => {
            params.repeated = data.repeated;
            return {action,data,params};
        }
    }
});
